import React, { Fragment } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import TicketsTable from "./components/TicketsTable";
import AddTicket from "./components/AddTicket";

export default function Tickets() {
  return (
    <Fragment>
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="tickets" />} />
        <div className="top-buttons">
          <AddTicket />
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TicketsTable />
      </MuiPaper>
    </Fragment>
  );
}
